/* tslint:disable */

/**
 */
export class Mesh3dInfo {
    id_mesh3d_info?: number;
    id_prod?: number;
    nb_points?: number;
    nb_cells?: number;
    nb_faces?: number;
    nb_internalfaces?: number;
    nb_boundaries?: number;
    nb_layers?: number;
    file_path?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/mesh-3d-info.ts